import { render, staticRenderFns } from "./WebsiteMessage.vue?vue&type=template&id=16b78098&"
import script from "./WebsiteMessage.vue?vue&type=script&lang=js&"
export * from "./WebsiteMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports